import isObject from '../type-check/is-object.js';
import checkTypeValidity from '../type-check/check-type-validity.js';
import clone from './clone.js';

/**
 * @func transformValues
 * @param {object} object - the object to transform.
 * @param {function} transform - the transform function to apply to all values
 * @return {object}
 * @desc Deep clones an object and recursively transforms all values
 * ```js
 * transformValues({ age: 1, favorites: { number: 2 } }, num => num + 1);
 * // returns { age: 2, favorites: { number: 3 } };
 * ```
 * @memberof module:Object
 * @instance
 */
function transformValues(object, transform) {
    if (!checkTypeValidity(['object'], object))
        return object;
    return transformRecursively(clone(object), transform);
}
function transformRecursively(object, transform) {
    Object.keys(object).forEach((key) => {
        if (isObject(object[key])) {
            transformRecursively(object[key], transform);
        }
        else {
            object[key] = transform(object[key]);
        }
    });
    return object;
}

export { transformValues as default };
